'use client';

import { Checkbox, ListItemText, MenuItem, TypographyOverflow } from 'ui';

interface Props {
  customerId: string;
  checked: boolean;
  name: string;
  onClick: (customerId: string) => void;
}

export const CustomerItem = ({ customerId, name, checked, onClick }: Props) => {
  const toggleChecked = () => {
    onClick(customerId);
  };

  return (
    <MenuItem
      value={customerId}
      sx={({ spacing }) => ({
        bgcolor: checked ? 'mintGreen.light' : 'transparent',
        maxWidth: spacing(40),
      })}
    >
      <Checkbox name="" checked={checked} onClick={toggleChecked} data-testid={`test-customer-${customerId}`} />
      <ListItemText onClick={toggleChecked} primary={<TypographyOverflow>{name}</TypographyOverflow>} />
    </MenuItem>
  );
};
